<template>
  <component
    :is="type"
    :class="[
      { 'typography-text-xl': size == 'xl' },
      { 'typography-text-lg': size == 'lg' },
      { 'typography-text-base': size == 'base' },
      { 'typography-text-xs md:typography-text-sm': size == 'sm' },
      { 'typography-text-xs': size == 'xs' || type === 'small' },
    ]"
  >
    <slot />
  </component>
</template>

<script setup lang="ts">
import type { TextProps } from '~/components/ui/Text/types';

withDefaults(defineProps<TextProps>(), {
  size: 'base',
  type: 'span',
});
</script>
